const styles = {
  wrapper: {
    flex: 1,
  },
  wrapperHorizontal: {
    display: 'flex',
    flexFlow: 'row nowrap',
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/SortableList/SortableList.styles.js